
import { Component, Vue } from 'vue-property-decorator'
import { State } from "vuex-class"
import User from "@/types/account/user"

@Component({
  components: {
  }
})
export default class Account extends Vue {
  private loading = false
  private email = ''
  private confirmDialog = false
  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  private get deleteActionValidated () {
    return this.user.email.toLowerCase() === this.email.toLowerCase()
  }

  private get error () {
    const authenticationError = this.$store.getters["account/authenticationError"]
    const globalError = this.$store.getters["error/error"]
    if (authenticationError || globalError) {
      this.loading = false
    }
    return authenticationError
  }

  private deleteAccount () {
    this.loading = true
    this.$store.dispatch('account/deleteUserAccount')
  }
}
